/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedTaskList } from '../models/PaginatedTaskList';
import type { Task } from '../models/Task';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AsyncService {
    /**
     * @returns PaginatedTaskList
     * @throws ApiError
     */
    public static asyncStatusList({
        limit,
        start,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        start?: number,
    }): CancelablePromise<PaginatedTaskList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/async/status/',
            query: {
                'limit': limit,
                'start': start,
            },
        });
    }
    /**
     * @returns Task
     * @throws ApiError
     */
    public static asyncStatusRetrieve({
        taskId,
        _delete,
    }: {
        taskId: string,
        _delete?: boolean,
    }): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/async/status/{task_id}/',
            path: {
                'task_id': taskId,
            },
            query: {
                'delete': _delete,
            },
        });
    }
}
